import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReasonidService } from 'src/app/service/reasonid.service';

@Component({
    selector: 'app-add-root-cause',
    templateUrl: './add-root-cause.component.html',
    styleUrls: ['./add-root-cause.component.scss'],
    standalone: false
})
export class AddRootCauseComponent implements OnInit {

  heading: string;
  errormsg
  eventType
  rootCause
  plannedBlowout
  owkBlowout
  selected_position_id: any;
  TierData: any;
  rootCauseId: any;
  yesNoList: { id: string; value: string; }[];

  constructor(public dialogRef: MatDialogRef<AddRootCauseComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly reasonIdService: ReasonidService) { }

  ngOnInit(): void {
    this.yesNoList = [
      { id: "1", value: 'Yes' },
      { id: "0", value: 'No' },
    ]
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    if (this.eventType == 'EDIT') { // NOSONAR
      console.info(this.dataStore.rootCauseId)
      this.rootCauseId = this.dataStore.rootCauseId
      this.rootCause = this.dataStore.rootCause
      this.plannedBlowout = this.dataStore.plannedBlowout == "Y" ? "1" : "0" ; // NOSONAR
      this.plannedBlowout = this.yesNoList.find(x => x.id == this.plannedBlowout)?.id // NOSONAR
      this.owkBlowout = this.dataStore.owkBlowout == "Y" ? "1" : "0" ;  // NOSONAR
      this.owkBlowout = this.yesNoList.find(x => x.id == this.owkBlowout)?.id // NOSONAR
    }

  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {
    this.errormsg = ""
    if (this.isValueOk(this.rootCause)){
      this.showError(this.constants.formInputError);
    }
    else {
      this.saveAPICall();
    }
  }

  saveAPICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      rootCauseId: this.rootCauseId,
      description: this.rootCause,
      plannedBlowout: this.plannedBlowout == "1" ? "1" : "0", // NOSONAR
      owkBlowout: this.owkBlowout == "1" ? "1" : "0", // NOSONAR
    }
    if (this.eventType == "ADD") { // NOSONAR
      this.reasonIdService.addRootCause(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }
        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);

        });

    }
    else if (this.eventType == "EDIT") { // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.reasonIdService.updateRootCause(updateObject).subscribe(
        response => {
          if (response == "Success") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(this.constants.APIErrorMessage);
          }

        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }



  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") // NOSONAR
    {
      return true;
    }
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}


